import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Response } from '@angular/http';

import { SignService } from '../../sign.service';
import { StorageService } from '../../../services/storage.service';
import { AuthenticationService } from '../../../services/authentication.service';
import { environment } from '../../../../environments/environment';

import * as CryptoJS from 'crypto-js';
import * as localforage from 'localforage';
import * as AES from 'crypto-js/aes';
import * as SHA256 from 'crypto-js/sha256';

@Component({
  selector: 'asv-signout',
  template: '<button (click)="logout()">Logout</button>',
  styles: [`
    :host {
      width: 100%;
    }
  `]
})
export class SignoutComponent {

  constructor(
    private router: Router,
    private storageService: StorageService,
    private auth: AuthenticationService,
    private signService: SignService
  ) {
    this.logout();
  }

  logout() {
    this.storageService.clear();
    localforage.clear();
    this.auth.isAuthenticated$.next(false);
    this.router.navigateByUrl('/signin');
  }

}
